<template>
  <!-- 该文件style没有添加scoped 需注意 ！！！ -->
  <div class="select-store-component">
    <el-dialog
      :title="$t('lcd.Devices.Bind Template Title')"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :before-close="handleClose"
      custom-class="dialog-bind-item-lcd"
      width="1000px"
      append-to-body
    >
      <div class="select-store-bd">
        <el-descriptions :column="3">
          <el-descriptions-item
            :label="$t('lcd.Devices.Store Name')"
            style="height: 32px; line-height: 32px"
            >{{ storeName }}</el-descriptions-item
          >

          <el-descriptions-item
            :label="$t('lcd.Devices.Bind Device Group Select')"
          >
            <el-select
              clearable
              size="mini"
              v-model="labelType"
              :placeholder="$t('lcd.Devices.Please select the group')"
            >
              <el-option
                v-for="item in groupOptions"
                :key="item.codeId"
                :label="item.codeName"
                :value="item.codeId"
              >
              </el-option>
            </el-select>
          </el-descriptions-item>
        </el-descriptions>
        <div class="templateName">
          <el-input
            clearable
            v-model="pageParams.templateName"
            size="mini"
            :placeholder="$t('lcd.Template.Please Enter Template Name')"
            @change="getList"
          ></el-input>
        </div>
      </div>
      <div class="cardWrap" style="padding: 10px">
        <el-row :gutter="18">
          <el-col
            :xs="12"
            :sm="8"
            :md="8"
            :lg="6"
            :xl="4"
            v-for="o in tableList"
            :key="o.id"
            style="margin-bottom: 18px"
          >
            <el-card
              class="elCard"
              shadow="hover"
              :body-style="{ padding: '0px' }"
            >
              <div style="width: 100%; padding: 8px 10px; position: relative">
                <div
                  class="materialWrap"
                  @click="handleConfirm(o)"
                  :style="{
                    cursor: 'pointer',
                    height: '130px',
                    'background-image':
                      'url(' +
                      o.templateImageUrlList[
                        o.templateImageUrlList.length - 1
                      ] +
                      ')',
                    'background-size': 'contain',
                    'background-position': 'center',
                    'background-repeat': 'no-repeat',
                  }"
                ></div>
              </div>
              <div class="imageName">
                <span>{{ o.templateName }}</span>
                <el-button
                  slot="reference"
                  class="copyButton"
                  icon="el-icon-view"
                  type="text"
                  :title="$t('lcd.Devices.Preview')"
                  @click="handlePreview(o)"
                  style="color: #35b871; background-color: #f5f5f5"
                ></el-button>
              </div>
              <div class="templateInfo">
                <span>{{ o.width }}-{{ o.height }}</span>
                <el-tooltip
                  :content="$t('lcd.Devices.Number AD')"
                  placement="bottom"
                  effect="dark"
                  v-if="o.isAddMarketPostion == 1"
                >
                  <el-button type="text" class="infoBtn"
                    ><airplay-icon
                      size="1x"
                      class="custom-class"
                    ></airplay-icon>
                    1
                  </el-button>
                </el-tooltip>
                <el-tooltip
                  :content="`${$t('lcd.Devices.The Most')}${o.itemQty}${$t(
                    'lcd.Devices.Item N'
                  )}`"
                  placement="bottom"
                  effect="dark"
                >
                  <el-button type="text" class="infoBtn"
                    ><shopping-bag-icon
                      size="1x"
                      class="custom-class"
                    ></shopping-bag-icon>
                    {{ o.itemQty }}
                  </el-button>
                </el-tooltip>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <div v-if="tableList.length < 1">
        <el-empty
          :image-size="200"
          :description="this.$t('lcd.noData')"
        ></el-empty>
      </div>
      <pagination :tableInfo="tableInfo" @changePage="getList" />
    </el-dialog>

    <!-- 预览模板dialog -->
    <el-dialog
      :title="$t('lcd.Template.previewObj.title')"
      :visible.sync="previewDialogVisible"
      :close-on-click-modal="false"
      :before-close="handlePreviewClose"
      custom-class="dialog-bind-item-lcd-preview"
      width="1000px"
      append-to-body
    >
      <el-carousel type="card" indicator-position="outside">
        <el-carousel-item v-for="(item, index) in previewLists" :key="item">
          <h3 class="templateType">{{ previewListsExplain[index] }}</h3>
          <el-image
            style="width: 100%; height: 500px"
            :src="item"
            fit="contain"
          ></el-image>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
  </div>
</template>
<script>
import { getCodeList } from "@/libs/api/aps"; // 获取下拉列表list接口
import {
  getItemList,
  getTemplateList,
  storeTemplateBind,
} from "@/libs/api/lcd";
import pagination from "@/components/pagination";
import {
  RepeatIcon,
  ShieldOffIcon,
  AirplayIcon,
  ShoppingBagIcon,
} from "vue-feather-icons";
export default {
  name: "selectStore",
  components: {
    pagination,
    ShieldOffIcon,
    ShoppingBagIcon,
    AirplayIcon,
    RepeatIcon,
  },
  props: {
    storeType: {
      type: Number,
    },
  },
  data() {
    return {
      storeName: localStorage.getItem("storeName"),
      dialogVisible: false,
      loading: false,
      tableList: [], // 模板列表
      tableInfo: {
        current: 1,
        size: 10,
        total: 0,
      },
      pageParams: {
        templateGroupId: "1", // 1：营销模板
        templateName: "", // 模板名称
        templateSize: "", // 分辨率
        activeState: "", // 激活状态(待发布/已发布)
        current: "1",
        size: "10",
      },
      initPageParams: {
        templateGroupId: "1", //1：营销模板
        templateName: "", // 模板名称
        templateSize: "", // 分辨率
        activeState: "", // 激活状态(待发布/已发布)
        current: "1",
        size: "10",
      },
      // previewDialogVisible  模板预览
      previewDialogVisible: false,
      previewLists: [],
      previewListsExplain: [
        this.$t("lcd.Devices.Unbind State"),
        this.$t("lcd.Devices.Item1"),
        this.$t("lcd.Devices.Item2"),
        this.$t("lcd.Devices.Item3"),
        this.$t("lcd.Devices.Item4"),
      ],
      labelType: "", // 用户选择设备组
      groupOptions: [],
      allGroups: [],
    };
  },
  created() {
    // 35为设备分组cateId
    this.getCodeList(35);
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        console.log("打开了");
        this.getList();
        this.labelType = ''
        this.storeName = localStorage.getItem("storeName");
      }
    },
  },
  methods: {
    async getCodeList(type) {
      try {
        const { data } = await getCodeList({ cateId: type });
        if (data.state === true) {
          let arr = data.data || [];
          if (type == 35) {
            // this.groupOptions = arr; // 设备组类型list
            this.groupOptions = [
              // 全部设备
              {
                codeId: 0,
                codeName: this.$t("lcd.Devices.All Device"),
              },
              // 所有无分组标签设备
              {
                codeId: 3,
                codeName: this.$t("lcd.Devices.All No Tag Device"),
              },
              ...arr,
            ];
          }
        } else {
          this.$message.error(data.message);
        }
      } catch (err) {
        const { message } = err;
        this.$message.error(message);
      }
    },
    getList() {
      this.tableList = [];
      // 获取素材列表
      const params = {
        ...this.pageParams,
        current: this.tableInfo.current,
        size: this.tableInfo.size,
      };
      getTemplateList(params).then((res) => {
        console.log(res);
        res.data.data.records.forEach((item) => {
          item.templateImageUrlList = item.templateImageUrl
            ? item.templateImageUrl.split(",")
            : [];
        });
        this.tableList = res.data.data.records;
        this.tableInfo.total = res.data.data.total;
      });
    },
    open() {
      this.dialogVisible = true;
    },
    // 取消选择
    handleClose() {
      this.dialogVisible = false;
    },
    // 点击确定
    handleConfirm(row) {
      // const userData = JSON.parse(localStorage.getItem("userData"));
      console.log(this.labelType);
      if (this.labelType === "") {
        this.$message.error(this.$t("lcd.Devices.Please select the group"));
        return;
      }
      const params = {
        storeId: localStorage.getItem("storeId"),
        taskTerminal: 0,
        templateId: row.templateId,
        labelType: this.labelType,
      };
      storeTemplateBind(params).then((res) => {
        console.log(res);
        if (res.data.code == 1) {
          this.$message.success(this.$t("lcd.Devices.Bind Tempalte Success"));
          this.dialogVisible = false;
          this.$emit("reGetList");
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    // 预览模板
    handlePreview(row) {
      console.log("handlePreview", row);
      this.previewDialogVisible = true;
      this.previewLists = row.templateImageUrl
        ? row.templateImageUrl.split(",")
        : [];
    },
    handlePreviewClose() {
      console.log("handlePreviewClose");
      this.previewDialogVisible = false;
      this.previewLists = [];
    },
  },
};
</script>
<style lang="scss">
.dialog-bind-item-lcd {
  margin-top: 0 !important;
  margin-bottom: 0;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  .el-dialog__body {
    // height: 400px;
    padding: 20px;
    box-sizing: border-box;
  }
  .el-descriptions__body .el-descriptions__table .el-descriptions-item__cell {
    line-height: 28px !important;
  }
  .select-store-bd {
    margin: 0 auto;
    width: 100%;
    padding-left: 9px;
    position: relative;
    .templateName {
      position: absolute;
      right: 9px;
      height: 32px;
      line-height: 32px;
      top: 0;
    }
    ::v-deep .el-radio {
      margin-top: 5px;
      padding: 10px 0;
      width: 100%;
    }
  }
  .box {
    height: 330px;
    margin-top: 20px;
  }
  .el-table thead {
    display: none;
  }
  .el-button {
    width: 110px;
  }
  .el-tree-node__content {
    height: 45px;
  }
  .el-table td.el-table__cell {
    border: none;
    width: 100%;
  }
  .el-table td.el-table__cell > .cell {
    justify-content: flex-start;
  }
  .el-table__row {
    display: flex;
  }
  // ::v-deep .el-radio{
  //   margin-top: 5px;
  //   padding: 20px 0;
  //   width: 100%;
  // }
  ::v-deep .el-table {
    .el-table__header {
      width: 100% !important;
    }
    th.el-table__cell > .cell {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;
    }
    td.el-table__cell > .cell {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .is-group tr:nth-child(2) .el-checkbox {
      display: none;
    }
  }

  // 重置样式
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .el-dialog__footer {
    padding: 20px 0;
  }
  .el-radio {
    padding: 14px 0;
    margin-bottom: 0;
  }

  .itemBtn {
    cursor: pointer;
    color: red;
  }
  .elCard {
    position: relative;
    .materialWrap {
      width: 100%;
      overflow: hidden;
      position: relative;
      // background-color: #f5f5f5;
    }
    .materialImage,
    .materialVideo {
      // max-width: 100%;
      // max-height: 100%;
      width: auto;
      height: auto;
      cursor: pointer;
      // left: 50%;
    }
    .format {
      position: absolute;
      top: 5px;
      right: 5px;
      width: 40px;
      text-align: center;
      padding: 2px 0;
      border-radius: 20px;
      z-index: 8;
      color: #fff;
      font-size: 12px;
      background-color: rgba(0, 0, 0, 0.2);
    }
    .imageInfo {
      line-height: 12px;
      padding: 3px 10px 0;
      position: relative;
      color: #c2c2c2;
      font-size: 12px;
    }
    .imageName {
      line-height: 16px;
      font-size: 13px;
      height: 36px;
      padding: 2px 40px 2px 10px;
      text-align: justify;
      display: flex;
      align-items: center;
      position: relative;
      // background-color: pink;
      .copyButton {
        width: auto;
        position: absolute;
        right: 10px;
        bottom: 5px;
        padding: 0;
        padding: 4px;
        font-size: 12px;
      }
    }
  }
  .elCard:hover {
    border: 1px solid #1dd670;
  }
  .templateInfo {
    font-size: 12px;
    padding: 0 10px 8px;
    color: #aaa;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .infoBtn {
    color: #aaa;
    padding: 0;
    font-size: 12px;
    width: auto;
    border: none;
    .custom-class {
      font-size: 13px;
    }
  }


  .cardWrap{
    max-height: 70vh;
    overflow-y: scroll;
  }
}
.dialog-bind-item-lcd-preview {
  margin-top: 5vh !important;
  .el-carousel__container {
    height: 600px;
  }
  .templateType {
    text-align: center;
    padding-bottom: 15px;
  }
}
</style>